import { OptionModel } from 'models/option';

export default function mapTextures(options: OptionModel[]) {
  return options.map(({ name, image, textureHeight, textureWidth }) => ({
    name, image, textureHeight, textureWidth
  }));
}
